// extracted by mini-css-extract-plugin
export default {"container":"TabloSlider_container__Z+BJN","image":"TabloSlider_image__xRw-f"};